module.exports = __webpack_public_path__ + "static/media/designer.c8814903.jpg";